// ============================================================
// rbush ベースの 2D 空間索引
// ============================================================
// 駅・バス停の静的レイヤを起動時に投入し、半径クエリで近傍を取り出す。
// 車両は件数が小さいのでポーリング毎に新しい index を作る。

import RBush from 'rbush'
import type { Entity, LatLon } from '../types'
import { bboxAround, distanceMeters } from '../util/distance'

interface IndexedItem {
  minX: number; minY: number; maxX: number; maxY: number
  entity: Entity
}

export class SpatialIndex {
  private tree = new RBush<IndexedItem>()
  private size = 0

  add(entities: Entity[]): void {
    const items: IndexedItem[] = entities.map((e) => ({
      minX: e.lon, minY: e.lat, maxX: e.lon, maxY: e.lat, entity: e,
    }))
    this.tree.load(items)
    this.size += items.length
  }

  clear(): void {
    this.tree.clear()
    this.size = 0
  }

  count(): number {
    return this.size
  }

  /** 円形領域 (中心 + 半径 m) で検索。距離昇順でソート済み。 */
  query(center: LatLon, radiusM: number): Entity[] {
    const bb = bboxAround(center, radiusM)
    const candidates = this.tree.search({
      minX: bb.minLon, minY: bb.minLat,
      maxX: bb.maxLon, maxY: bb.maxLat,
    })
    return candidates
      .map((c) => ({ entity: c.entity, d: distanceMeters(center, c.entity) }))
      .filter((x) => x.d <= radiusM)
      .sort((a, b) => a.d - b.d)
      .map((x) => x.entity)
  }
}
